<script setup lang="ts">
import { ref, onMounted } from 'vue'
import ProjectCards from '@/components/ProjectCards.vue'
import PageContainer from '@/components/PageContainer.vue'
import { api } from '@/api/api.js'

interface FrontendProject {
  id: number | string
  title?: string
  // остальные поля проекта сейчас типизируем гибко
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

const projects = ref<FrontendProject[]>([])
const isLoading = ref(false)
const error = ref<string | null>(null)

const fetchProjects = async () => {
  isLoading.value = true
  error.value = null
  try {
    projects.value = await api.getAllProjects()
  } catch (err) {
    console.error('Ошибка при получении проектов:', err)
    error.value = 'Не удалось загрузить проекты. Попробуйте обновить страницу.'
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
  fetchProjects()
})
</script>

<template>
  <PageContainer>
    <div class="wrapper">
      <div>
        <h1 class="text-lg">ПРОЕКТЫ</h1>
      </div>
      <div v-if="error" class="projects-error">
        <p>{{ error }}</p>
      </div>
      <ProjectCards v-else-if="isLoading || projects.length > 0" :projects="projects" />
    </div>
  </PageContainer>
</template>

<style scoped>
.wrapper {
  margin: 0;
}

.projects-error {
  width: 100%;
  padding: 4rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 48rem) {
  .wrapper {
    margin-top: 1.875rem;
  }
}

@media (max-width: 36rem) {
  .wrapper {
    margin-top: 1.25rem;
  }
}
</style>
